import './collapse-button.css';

import React from 'react';

import Collapse from './icons/Collapse.svg';
import Collapsed from './icons/Collapsed.svg';

interface CollapseButtonProps {
  collapsed: boolean;
  handleCollapse: (args) => void;
}

const CollapseButton = ({ collapsed, handleCollapse }: CollapseButtonProps) => (
  <div
    className={collapsed ? `collapsed-button` : `collapse-button`}
    onClick={() => handleCollapse(!collapsed)}
  >
    <img src={collapsed ? Collapsed : Collapse} alt="" />
  </div>
);

export default CollapseButton;
